import React from 'react';
import Tile from './Tile';
import { StyledMetricGroupRenderer, TableHeaderWrapper } from './styled';
import EmptyPlaceholder from '@components/common/EmptyPlaceholder';

const RenderSessionTag = ({ sessionTags = [], title }) => (
  <StyledMetricGroupRenderer>
    {title
      ? (
        <TableHeaderWrapper>
          {title}
        </TableHeaderWrapper>
      ) : null}
    <React.Fragment key="cards">
      {
       sessionTags && Array.isArray(sessionTags) ? sessionTags.map(metric => (
          <Tile
            key={`${metric.name}+${metric.value}`}
            name={metric.name}
            value={metric.value}
          />
        )) :
        <EmptyPlaceholder
        className=""
        emptyPlaceholder="No Data"
        />
      }
    </React.Fragment>
  </StyledMetricGroupRenderer>
);

export default RenderSessionTag;
